import { useMemo } from 'react';
import { capitalize } from 'lodash';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../context/installation';
import { AllTariffsQuery, AllTariffsQueryVariables } from '../../../../data-access/gql-types/graphql';
import { ALL_TARIFFS } from '../../../../data-access/queries/tariffs';
import { tariffKind } from '../../modules/channel-details/optimizer/configuration/utils/tariff-kind';
import { TariffItem } from '../../types/tariffs';

export const useGetTariffs = () => {
  const { skipLavvaFetch } = useInstallationContext();
  const { data } = useQuery<AllTariffsQuery, AllTariffsQueryVariables>(ALL_TARIFFS, {
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    skip: skipLavvaFetch,
  });

  const allTariffs = useMemo(() => {
    const list: TariffItem[] = [];

    data?.allTariffs?.map((x) => {
      if (!x) return;
      const { operator, tariff } = tariffKind[x.kind];

      const operatorExists = list.findIndex((o) => o.operator.toLowerCase() === operator.toLowerCase());

      if (operatorExists === -1) {
        list.push({
          operator: capitalize(operator),
          tariffs: [
            {
              name: capitalize(tariff),
              hoursRanges: x.ranges,
              wholeHolidaysCheaper: x.wholeHolidaysCheaper,
              wholeWeekendCheaper: x.wholeWeekendCheaper,
              ignoreSummerTimeChanges: x.ignoreSummerTimeChanges,
            },
          ],
        });
      } else {
        list[operatorExists].tariffs.push({
          name: capitalize(tariff),
          hoursRanges: x.ranges,
          wholeHolidaysCheaper: x.wholeHolidaysCheaper,
          wholeWeekendCheaper: x.wholeWeekendCheaper,
          ignoreSummerTimeChanges: x.ignoreSummerTimeChanges,
        });
      }
    });

    return list;
  }, [data]);

  return {
    allTariffs,
    flatTariffs: data?.allTariffs || [],
  };
};
